import { z } from "zod";

import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

const DEFAULT = "";
const MIN = 0;
const MAX = 100;

const schema = z
	.string()
	.trim()
	.pipe(
		z.union([
			z.literal("").transform(() => undefined),
			z.coerce.number().min(MIN, "Must be a non-negative number").max(MAX, `Must not exceed ${MAX}`),
		]),
	);

type WidgetDecimals = ImpulseFormUnit<string, ReadonlyArray<string>, undefined | number>;

function init(initial = DEFAULT): WidgetDecimals {
	return ImpulseFormUnit(initial, {
		isInputDirty: isStringDirty,
		schema,
	});
}

const WidgetDecimals = {
	default: DEFAULT,
	min: MIN,
	max: MAX,
	init,
} as const;

export { WidgetDecimals };
